class Party{
    constructor(id, adminEmail, partyName, guestList){
        this.id = id;
        this.adminEmail = adminEmail;
        this.partyName = partyName;
        this.guestList = guestList;
    }
}

export default Party;